// extracted by mini-css-extract-plugin
module.exports = {"s1djuio7":"s1djuio7","b13clb2b":"b13clb2b"};